var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22549 11.6641H3.33439C2.41786 11.6641 1.66797 12.414 1.66797 13.3305V18.3298H7.22549V11.6641Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1059 8.33594H8.88127C7.96473 8.33594 7.21484 9.08583 7.21484 10.0024V18.3345H12.7724V10.0024C12.7724 9.08583 12.0308 8.33594 11.1059 8.33594Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6645 14.1641H12.7734V18.3301H18.331V15.8305C18.331 14.914 17.5811 14.1641 16.6645 14.1641Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4302 1.72236L10.8718 2.60556C10.9301 2.73054 11.0884 2.84719 11.2217 2.86385L12.0216 2.99717C12.5299 3.08049 12.6548 3.45542 12.2882 3.8137L11.6633 4.43861C11.555 4.54693 11.4967 4.74691 11.53 4.88855L11.705 5.65512C11.8466 6.26336 11.5217 6.49667 10.9884 6.18005L10.2385 5.73844C10.1052 5.65512 9.88025 5.65512 9.74693 5.73844L8.99704 6.18005C8.46379 6.49667 8.13883 6.26336 8.28048 5.65512L8.45546 4.88855C8.48878 4.74691 8.43046 4.5386 8.32214 4.43861L7.70556 3.82204C7.33895 3.45543 7.4556 3.08881 7.97219 3.00549L8.77207 2.8722C8.90539 2.8472 9.0637 2.73055 9.12202 2.6139L9.56362 1.73067C9.80526 1.24741 10.1885 1.24743 10.4302 1.72236Z",
    stroke: "#344054",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.12849bf6d9afc910001f9089b0f554cd.svg";
export { ForwardRef as ReactComponent };